<script setup lang="ts">
import type { CmsElementBigTextBox } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementBigTextBox;
}>();

const {image, heading} = props.content?.config;

</script>
<template>
  <section v-if="heading.value && image.value" class="section section-main section-about section-about--alt" :style="props.style" :class="props.class">
   <div class="container" >
     <div class="row">
       <div class="col-12" style="position: relative;">
         <h3 class="overlay-heading">{{heading.value}}</h3>
         <NuxtImg style="width: 100%" v-if="image" :src="image.value.url" />
       </div>
     </div>

   </div>
  </section>
</template>